import { useState } from "react";
import Navbar from "@/components/homepage/Navbar";
import HomepageFooter from "@/components/homepage/HomepageFooter";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import HomepageStickyCta from "@/components/homepage/HomepageStickyCta";
import NewsletterHero from "@/components/newsletter/Hero";
import NewsletterPostList from "@/components/newsletter/NewsletterPostList";
import InviteSection from "@/components/homepage/InviteSection";

const Newsletter = () => {
  const [leadModal, setLeadModal] = useState<{ open: boolean; email: string }>({
    open: false,
    email: "",
  });

  const openLeadModal = (email: string) => {
    setLeadModal({ open: true, email });
  };

  const closeLeadModal = () => {
    setLeadModal({ open: false, email: "" });
  };

  return (
    <main
      className="flex min-h-svh w-full flex-col bg-black pb-24 text-white max-md:pb-[calc(5rem+env(safe-area-inset-bottom,0px))]"
      style={{ fontFamily: "var(--font-fira)" }}
    >
      <Navbar />
      <NewsletterHero />
      <NewsletterPostList />
      <InviteSection />
      <HomepageFooter onEmailContinue={openLeadModal} />
      <HomepageStickyCta
        heroSectionId="newsletter-hero"
        ctaSectionId="homepage-cta"
        marketingBasePath="/newsletter"
        onEmailContinue={openLeadModal}
      />
      <HomepageLeadModal
        open={leadModal.open}
        initialEmail={leadModal.email}
        onClose={closeLeadModal}
      />
    </main>
  );
};

export default Newsletter;
